import type { ItemFrameSource } from '../render-config';

/**
 * A frame's source as the key of what it loads (#287): its model, without
 * an item's effect look. A new look (another upgrade level) changes on the
 * loaded model in place, so it keeps the same key and nothing reloads. The
 * worker and the page key frames the same way, to match a loaded frame to
 * what was asked for.
 */
export function toItemFrameModelKey(source: ItemFrameSource): string {
    return source.kind === 'item' ? JSON.stringify({ kind: source.kind, modelId: source.modelId }) : JSON.stringify(source);
}
